export const downloadFile = async (urlOrContent, fileName, options = { isText: false }) => {
  try {
    let blob;

    if (options.isText) {
      blob = new Blob([urlOrContent], { type: "text/plain;charset=utf-8" });
    } else {
      const response = await fetch(urlOrContent, { method: "GET" });
      if (!response.ok) throw new Error("Network response was not ok");
      blob = await response.blob();
    }

    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);

  } catch (error) {
    if (!options.isText) {
      const link = document.createElement("a");
      link.href = urlOrContent;
      link.download = fileName || "download";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Failed to download text file:", error);
    }
  }
};